<template>
  <h1>Weekend</h1>
  <h3>Get home on time on a Friday afternoon.</h3>
  <h4>v0.1.0</h4>
  <p>
    Welcome to <b>Weekend</b>, a web app designed to help get junior doctors working in Queensland, Australia home on time on a Friday afternoon.
  </p>
  <p>
    <b>Weekend</b> harnesses the power of automation to enable you to order blood tests for all of your patients in a fraction of the time it would take to do this by hand.
  </p>
  <p>
    Better yet, it prints a summary of the blood tests you've ordered, which is great for sharing with your registrar or the weekend team.
  </p>
  <p>Happy Friday.</p>
  <p class="last">From <a href="https://joshcase.dev">Josh Case</a>, junior doctor and software developer</p>
  <StepOne v-on:update:dates="this.dates = $event"/>
  <StepTwo v-on:update:userDetails="this.userDetails = $event"/>
  <StepThree />
  <StepFour :dates="dates" :patients="patients" @addOrder="addOrder" @removeOrder="removeOrder"/>
  <StepFive :dates="dates" :patients="patients" :orders="orders" :userDetails="userDetails"/>
</template>

<script>
import StepOne from './components/StepOne.vue'
import StepTwo from './components/StepTwo.vue'
import StepThree from './components/StepThree.vue'
import StepFour from './components/StepFour.vue'
import StepFive from './components/StepFive.vue'

export default {
  name: 'App',
  components: { StepOne, StepTwo, StepThree, StepFour, StepFive },
  data() {
    return {
      dates:[],
      orders:{},
      userDetails: {},
      patients: [
        {
          "firstName": "Billy",
          "lastName": "Thomas",
          "id": "T123456",
          "dateOfBirth": "1/1/1901"
        },
        {
          "firstName": "Sue",
          "lastName": "Prior",
          "id": "T654321",
          "dateOfBirth": "1/2/1901"
        },
        {
          "firstName": "Adam",
          "lastName": "Wallace",
          "id": "T326521",
          "dateOfBirth": "1/3/1901"
        },
        {
          "firstName": "Samantha",
          "lastName": "Worsnop",
          "id": "T232651",
          "dateOfBirth": "1/4/1901"
        },
        {
          "firstName": "Betty",
          "lastName": "Lyon",
          "id": "T523261",
          "dateOfBirth": "1/5/1901"
        },
      ]
    }
  },
  methods: {
    addOrder(event) {
      // If there are no orders for this patient yet, create empty map
      if (!Object.keys(this.orders).includes(event.patient.id)) {
        this.orders[event.patient.id] = {}
      }

      // If there are no orders for this patient on this day yet, create empty list
      if (!Object.keys(this.orders[event.patient.id]).includes(event.date)) {
        this.orders[event.patient.id][event.date] = []
      }

      // If this test has not been ordered on this date yet, add the test order
      if (!this.orders[event.patient.id][event.date].includes(event.test)) {
        this.orders[event.patient.id][event.date].push(event.test)
      }
      console.log(this.orders)
    },
    removeOrder(event) {
      // Ensure there are orders for this patient
      if (!Object.keys(this.orders).includes(event.patient.id)) {
        return
      }
      var currentPatientsOrders = this.orders[event.patient.id]

      // Ensure there are orders for this patient on this day
      if (!Object.keys(currentPatientsOrders).includes(event.date)) {
        return
      }

      // Remove the test if it is in the 
      currentPatientsOrders[event.date] = currentPatientsOrders[event.date].filter(function(value){
          return value != event.test
        })
      console.log(this.orders)
    }
  }
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
}

body {
  height: 100vh;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: rgb(240, 240, 240);
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  padding-top: 40px;
}

#app p {
  max-width: 800px;
  margin-bottom: 10px;
  text-align: left;
}

#app p.last {
  margin-bottom: 40px;
}

h3 {
  margin-bottom: 20px;
}

.step-section {
  background-color: white;
  border: 1px solid rgb(100, 100, 100);
  border-radius: 4px;
  width: 760px;
  padding: 20px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  text-align: left;
}
</style>
